/**
 * Feature Flags Configuration
 * 
 * Centralized feature flag system for Pebble Health.
 * Set flags to `true` to enable, `false` to disable.
 * 
 * ─── FLAGS ───
 * 
 * IMPROVED_VITALS_FLOW (default: false)
 *   Controls an improved flow for blood sugar, blood pressure, and cholesterol
 *   questions in the survey. The current flow in SurveyPage4.js asks chronic
 *   diseases first, then blood sugar/cholesterol/BP status, then smoking/radiation
 *   all on one page. This creates a disjointed experience where vitals questions
 *   are sandwiched between unrelated medical history questions.
 * 
 *   When enabled, this flag would:
 *   - Group blood sugar, blood pressure, and cholesterol questions together
 *     in a dedicated "Vitals & Metabolic Health" section
 *   - Move them to their own survey page (or sub-section) with contextual
 *     explanations for why each metric matters
 *   - Add conditional follow-up questions (e.g., if BP is high, ask about
 *     medication; if blood sugar is diabetic, ask about HbA1c)
 *   - Separate smoking/radiation into a distinct "Exposure History" section
 * 
 *   Currently guarded components:
 *   - SurveyPage4.js — question ordering and grouping
 *   - healthScreeningRecommendations.js — enhanced vitals risk logic
 *   - ResultPage.js — vitals dashboard display
 * 
 * PRIMARY_SECONDARY_DASHBOARD (default: true)
 *   Shows primary (government-guideline-backed) screening recommendations
 *   prominently at the top of the results page in a dashboard-style layout,
 *   with secondary (personalized/research-based) screenings in a collapsible
 *   section below.
 * 
 * HEALTH_SCREENING_OVERVIEW (default: false)
 *   Shows the "Your Health Screening Overview" section on the results page
 *   with blood sugar, cholesterol, and blood pressure cards. Currently hidden
 *   because this section is not fully developed yet.
 */

const FEATURE_FLAGS = {
  IMPROVED_VITALS_FLOW: false,
  PRIMARY_SECONDARY_DASHBOARD: true,
  HEALTH_SCREENING_OVERVIEW: false,
  RECOMMENDATION_AUDIT_PAGE: false,
};

export default FEATURE_FLAGS;
